export function getLabel(data) {
  return data?.label || '';
}

export default {
  install(Vue) {
    Vue.filter('label', getLabel);
  },
};
